import { createRootRoute, Outlet } from '@tanstack/react-router'
import { ThemeProvider } from '@/components/theme-provider'
import { AuthProvider } from '@/contexts/auth-context'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ConditionalLayout from '@/components/layout/conditional-layout'
import { Toaster } from '@/components/ui/toaster'

const queryClient = new QueryClient()

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  // Replace server-side cookie reading with localStorage
  const defaultSidebarOpen = typeof window !== 'undefined'
    ? localStorage.getItem('sidebar:state') !== 'false'
    : true

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ConditionalLayout defaultSidebarOpen={defaultSidebarOpen}>
            <Outlet />
            <Toaster />
          </ConditionalLayout>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
